// Country IDs matching `t_country` rows. Keep in sync with CountryUtils.getLocalCountries.
export const COUNTRY_BE = 2;
export const COUNTRY_FR = 5;
export const COUNTRY_LU = 11;
export const COUNTRY_NL = 12;
export const COUNTRY_CH = 203;

export const EU_COUNTRIES: string[] = [
    'at', // Austria
    'be', // Belgium
    'bg', // Bulgaria
    'hr', // Croatia
    'cy', // Cyprus
    'cz', // Czech Republic
    'dk', // Denmark
    'ee', // Estonia
    'fi', // Finland
    'fr', // France
    'de', // Germany
    'gr', // Greece
    'hu', // Hungary
    'ie', // Ireland
    'it', // Italy
    'lv', // Latvia
    'lt', // Lithuania
    'lu', // Luxembourg
    'mt', // Malta
    'nl', // Netherlands
    'pl', // Poland
    'pt', // Portugal
    'ro', // Romania
    'sk', // Slovakia
    'si', // Slovenia
    'es', // Spain
    'se', // Sweden
];
